const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 443 430",
    id: "svg2312",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 418.00001,135.21352 V 82.129691 H 332 L 321.00001,136.2151 H 352 l -10,50.07907 h -31 l -11,54.08542 c -1,4.00632 -1,6.00948 -1.99999,9.01423 -3.00001,17.02689 5,16.02531 28,16.02531 L 315,318.50295 h -39.99999 c -38.00001,0 -69,0 -61.00001,-40.06327 1.00001,-6.00948 3,-12.01897 4,-18.02847 l 14,-74.11704 h -30 l 10,-50.07907 h 30 L 253,82.129691 H 225 V 0 H 123 V 166.26255 H 0 c 3,43.06801 41,49.07749 55,80.12652 10.000001,21.03322 18,58.09174 46,58.09174 21,0 21,-28.04429 49.00001,-28.04429 C 177,276.43652 190,328.51877 214,371.58678 c 18,34.05377 49,56.08856 76,58.09172 23,2.00317 34,-6.00948 34,-6.00948 -6,-12.01898 -9,-25.03955 -9,-43.06801 0,-28.04429 21,-55.08699 46,-74.11704 34.00001,-25.03954 70,-34.05377 82,-37.05852 v -86.13602 c 0,1.00158 -24.99999,-12.01898 -24.99999,-48.07591 z M 278,264.41755 314,82.129691 H 272 L 236,264.41755 Z M 325,24.037959 h -42 l -7.99999,40.063263 h 42 z",
    fill: "#cc0000",
    id: "path2310",
    style: {
      strokeWidth: 10.0079
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTi);
export default __webpack_public_path__ + "static/media/Ti.a7d3341a381d1c1cf0e7a2cdf35380c7.svg";
export { ForwardRef as ReactComponent };